import * as Sentry from '@sentry/react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Import tailwind generated styles
import '@/index.css';

// Import i18n configuration
import '@/core/i18n/i18n';

// Import main application component
import App from '@/App.tsx';

// Sentry initialization
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [],
  environment: import.meta.env.VITE_ENVIRONMENT,
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
